/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Decrease_Playback_SpeedInputs */

const en_shortcut_keys_name_decrease_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Decrease_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decrease Playback Speed`)
};

const fr_shortcut_keys_name_decrease_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Decrease_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminuer la vitesse de lecture`)
};

const de_shortcut_keys_name_decrease_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Decrease_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiedergabegeschwindigkeit verringern`)
};

const it_shortcut_keys_name_decrease_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Decrease_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminuire la velocità di riproduzione`)
};

const ru_shortcut_keys_name_decrease_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Decrease_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снизить скорость воспроизведения`)
};

const es_shortcut_keys_name_decrease_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Decrease_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disminuir la velocidad de reproducción`)
};

const zh_cn2_shortcut_keys_name_decrease_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Decrease_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`降低播放速度`)
};

const ja_shortcut_keys_name_decrease_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Decrease_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再生速度を下げる`)
};

const hi_shortcut_keys_name_decrease_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Decrease_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेबैक गति कम करें`)
};

const pt_pt2_shortcut_keys_name_decrease_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Decrease_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminuir a velocidade de reprodução`)
};

/**
* | output |
* | --- |
* | "Decrease Playback Speed" |
*
* @param {Shortcut_Keys_Name_Decrease_Playback_SpeedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_decrease_playback_speed = /** @type {((inputs?: Shortcut_Keys_Name_Decrease_Playback_SpeedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Decrease_Playback_SpeedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_decrease_playback_speed(inputs)
	if (locale === "de") return de_shortcut_keys_name_decrease_playback_speed(inputs)
	if (locale === "it") return it_shortcut_keys_name_decrease_playback_speed(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_decrease_playback_speed(inputs)
	if (locale === "es") return es_shortcut_keys_name_decrease_playback_speed(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_decrease_playback_speed(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_decrease_playback_speed(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_decrease_playback_speed(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_decrease_playback_speed(inputs)
	return en_shortcut_keys_name_decrease_playback_speed(inputs)
});